import React from "react";

type Reason = {
  icon: string;
  title: string;
  description: string;
};

const ReasonCard: React.FC<Reason> = ({ icon, title, description }) => (
  <div className="flex items-start gap-md p-md bg-white/5 rounded-xl border border-white/10">
    <div className="bg-secondary p-sm rounded-lg shrink-0">
      <span className="material-symbols-outlined text-white">{icon}</span>
    </div>
    <div>
      <h4 className="font-headline-md text-white text-lg mb-xs">{title}</h4>
      <p className="text-white/70 font-body-md">{description}</p>
    </div>
  </div>
);

export const WhyChooseUsSection: React.FC = () => {
  const reasons: Reason[] = [
    {
      icon: "verified",
      title: "Reliability",
      description:
        "Consistency you can count on. We arrive on time and deliver on every promise, every single visit.",
    },
    {
      icon: "health_and_safety",
      title: "Hygiene",
      description:
        "Clinical-grade sanitation practices that prioritize the health and safety of your residents or staff.",
    },
    {
      icon: "bolt",
      title: "Effectiveness",
      description:
        "Utilizing state-of-the-art equipment and specialized techniques for a superior clean that lasts.",
    },
  ];

  return (
    <section className="py-xl bg-brand-gradient relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="grid grid-cols-6 h-full w-full">
          <div className="border-r border-white/20" />
          <div className="border-r border-white/20" />
          <div className="border-r border-white/20" />
          <div className="border-r border-white/20" />
          <div className="border-r border-white/20" />
          <div />
        </div>
      </div>
      <div className="max-w-container-max mx-auto px-md relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-lg">
          <div className="w-full lg:w-1/2">
            <h2 className="font-headline-lg text-headline-lg text-white mb-md">
              Why Choose Kolomaka?
            </h2>
            <p className="font-body-lg text-white/80 mb-lg">
              We don't just clean; we restore health and order to your
              environment through rigorous standards and professional integrity.
            </p>
            <div className="space-y-md">
              {reasons.map((reason) => (
                <ReasonCard key={reason.title} {...reason} />
              ))}
            </div>
          </div>
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                alt="Kolomaka Cleaning services overview"
                className="aspect-square w-full object-cover"
                loading="lazy"
                decoding="async"
                fetchPriority="low"
                src="https://lh3.googleusercontent.com/aida-public/AB6AXuBLzE9-UBYb0nR6qSNwGj-4RsJywmZ2VTTXBi6Lcc7l1OEpsngPhDUtTlxzN7c6muT58at22SWQQwVqpRtD-q9ipL474AO1gT5qQi8ugoF0uNKK_PkU3YRxK6bkgMVLk4UxOC7iU--EbPHVL1KNqxP3ofSH8uvBtKzO04bDISDzkhc2W5UpsyWGZQiqBRSTHe-D3C_pdlW28SH7XA3gL35Gp2jJSKamjaYDx22yXa5luFScxgY_-arab_DfTHWviyMBxQUQYlGGfKng"
              />
              <div className="absolute bottom-md left-md right-md bg-white p-md rounded-xl shadow-lg flex items-center justify-between">
                <div>
                  <div className="text-primary font-bold text-headline-md">
                    100%
                  </div>
                  <div className="text-on-surface-variant text-sm">
                    Satisfaction Rate
                  </div>
                </div>
                <div className="h-10 w-[1px] bg-outline-variant" />
                <div>
                  <div className="text-primary font-bold text-headline-md">
                    500+
                  </div>
                  <div className="text-on-surface-variant text-sm">
                    Happy Clients
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
